// extracted by mini-css-extract-plugin
module.exports = {"card":"invite_card__1Ys1G","cardText":"invite_cardText__1JLm9","formWrapper":"invite_formWrapper__2o0-5","invitedWrapper":"invite_invitedWrapper__JwDIm"};